export const isInLifecycle = (currentDocumentLifecycle: server.dto.DocumentLifeCycles, inLifecycles: server.dto.DocumentLifeCycles[]) => {
  return inLifecycles.includes(currentDocumentLifecycle);
};

export const hasDocumentBeenSubmitted = (lifeCycle: server.dto.DocumentLifeCycles) => !isInLifecycle(lifeCycle, ["draft", "review"]);

export const isDiscarded = (lifeCycle: server.dto.DocumentLifeCycles) => lifeCycle === "discarded";

export const isPendingOrCompleted = (lifeCycle: server.dto.DocumentLifeCycles) => isInLifecycle(lifeCycle, ["pending", "completed"]);

export const isDocumentOverdue = (doc: server.dto.InvoiceForList | server.dto.DocumentForList) => doc.overDue &&
  !isInLifecycle(doc.lifeCycle.value, ["completed", "discarded"]);

export const messageTemplateForESignSigner = (documentType: server.dto.DocumentTypes): server.dto.MessageTemplateTypes => {
  switch (documentType) {
    case "contract":
      return "invitationForESignContractForSigner";
    case "purchaseAgreement":
      return "invitationForESignPurchaseAgreementForSigner";
    case "quote":
      return "invitationForESignQuoteForSigner";
    default:
      throw new Error(`No template type for document type ${documentType}`);
  }
};

export const emailTemplateTypeForDocumentType = (documentType: server.dto.DocumentTypes): server.dto.MessageTemplateTypes => {
  switch (documentType) {
    case "contract":
      return "contractEmailTemplate"
    case "purchaseAgreement":
      return "purchaseAgreementEmailTemplate"
    case "quote":
      return "quoteEmailTemplate"
    case "invoice":
      return "invoiceEmailTemplate"
    default:
      throw new Error(`No template type for document type ${documentType}`);
  }
}

export const messageTemplateForESignViewer = (documentType: server.dto.DocumentTypes): server.dto.MessageTemplateTypes => {
  switch (documentType) {
    case "contract":
      return "invitationForESignContractForViewer";
    case "purchaseAgreement":
      return "invitationForESignPurchaseAgreementForViewer";
    case "quote":
      return "invitationForESignQuoteForViewer";
    default:
      throw new Error(`No template type for document type ${documentType}`);
  }
};


interface DocumentTypeOption {
  type: server.dto.DocumentTypes;
  text: string;
}
export const getEnabledV1DocumentTypes = (): DocumentTypeOption[] => {
  return [
    { type: "quote" as const, text: site.currentEnvironment.quote.singular, enabled: site.currentEnvironment.quote.enabled && site.currentEnvironment.quote.hasV1 && site.permissions.quote.canCreate },
    { type: "purchaseAgreement" as const, text: site.currentEnvironment.purchaseAgreement.singular, enabled: site.currentEnvironment.purchaseAgreement.enabled && site.currentEnvironment.purchaseAgreement.hasV1 && site.permissions.purchaseAgreement.canCreate },
    { type: "contract" as const, text: site.currentEnvironment.contract.singular, enabled: site.currentEnvironment.contract.enabled && site.currentEnvironment.contract.hasV1 && site.permissions.contract.canCreate },
    { type: "invoice" as const, text: site.currentEnvironment.invoice.singular, enabled: site.currentEnvironment.invoice.enabled && site.currentEnvironment.invoice.hasV1 && site.permissions.invoice.canCreate },
  ]
    .filter(dt => dt.enabled)
    .map<DocumentTypeOption>(dt => ({ type: dt.type, text: dt.text }));
}

export const getNewLabelForDocumentType = (documentType: server.dto.DocumentTypes): string => {
  switch (documentType) {
    case "contract": return site.currentEnvironment.contract.newLabel;
    case "purchaseAgreement": return site.currentEnvironment.purchaseAgreement.newLabel;
    case "quote": return site.currentEnvironment.quote.newLabel;
    case "invoice": return site.currentEnvironment.invoice.newLabel;
    default: throw new Error(`No new label for document type ${documentType}`);
  }
}